import React from 'react';
import UserAccount from '../UserAccount';

function Login() {
  return (
    <div className="login">
      <UserAccount />
    </div>
  );
}

export default Login;
